const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 13/12/16.
 */
const React = require('react');

const {formatText} = require('core/i18n').i18n;
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');
const OtherIncomeList = require('../OtherIncomeList/OtherIncomeList');

const mockHelper = require('../../../utilities/mockDataHelper');

class CompanyData extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values.length >= 1) {
            initialState = this.props.values[0]
        } else {
            initialState = {
                name: '',
                cif: '',
                telephone: '',
                seniorityInCompany: '',
                residence: '',
                locality: '',
                laborOld: '',
                employmentRelationship: '',
                netMonthlyPay: '',
                extraPayments: ''
            };
        }
        this.state = initialState;
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.onDataReceiver = this.onDataReceiver.bind(this);
    }

    onDataReceiver(data) {
        this.props.dataReceiver([this.state, data]);
    }

    handleOnBlur(event) {
        this.setState({[event.target.name] : event.target.value});
    }

    handleOnChange(event) {
        this.setState({employmentRelationship: event.value});
    }
// [{datos laboral data}, [[datos company data], [datos other incomes]]]
    render() {
        this.props.dataReceiver(this.state);
        return (
            <div className="laboral-data">
                <Accordion customClassName="laboral-data__accordion" isExpanded={true}>
                    <AccordionHeader
                        name="AccordionHeader"
                        isRightArrowPosition={true}>
                        <h4 className="laboral-data__subtitle">{formatText('contractsView-checkingAccountLaboralDataCompanyDataSubtitle')}</h4>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div>
                            <div>
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataNameTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="name"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="name"
                                        type="text"
                                        value={this.state.name}
                                    />
                                </div>
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataCIFTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="cif"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="cif"
                                        type="text"
                                        value={this.state.cif}
                                    />
                                </div>
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataTelephoneTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="telephone"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="telephone"
                                        type="text"
                                        value={this.state.telephone}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataAntiqueTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="seniorityInCompany"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="seniorityInCompany"
                                        type="text"
                                        value={this.state.seniorityInCompany}
                                    />
                                </div>
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataAddressTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="residence"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="residence"
                                        type="text"
                                        value={this.state.residence}
                                    />
                                </div>
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataLocationTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="locality"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="locality"
                                        type="text"
                                        value={this.state.locality}
                                    />
                                </div>
                            </div>
                            {/*Necesitamos un divisor aqui :P */}
                            <div className="laboral-data__input-row">
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataLaborOldTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="laborOld"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="laborOld"
                                        type="text"
                                        value={this.state.laborOld}
                                    />
                                </div>
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataEmploymentRelationshipTitle')}</div>
                                    <OKSelect
                                        placeholder="Selecciona"
                                        searchable={true}
                                        options={mockHelper.mockEmploymentRelationship()}
                                        onChange={this.handleOnChange}
                                        value={this.state.employmentRelationship}
                                    />
                                </div>
                                <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDatamonthlyPayTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="netMonthlyPay"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="netMonthlyPay"
                                        type="text"
                                        value={this.state.netMonthlyPay}
                                    />
                                </div>
                            </div>

                            <div>
                                <div className="laboral-data__workers-data--second-row laboral-data__form-element">
                                    <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataPaidExtraPerYearTitle')}</div>
                                    <InputSafe
                                        label={null}
                                        name="extraPayments"
                                        onBlur={this.handleOnBlur}
                                        onChange={null}
                                        referenceName="extraPayments"
                                        type="text"
                                        value={this.state.extraPayments}
                                    />
                                </div>
                            </div>
                        </div>
                    </AccordionBody>
                </Accordion>
                <OtherIncomeList
                    dataReceiver={this.onDataReceiver}
                    values={this.props.values ? this.props.values[1] : []} rows={4}/>
            </div>

        );
    }
}

CompanyData.propTypes = {
    values: PropTypes.array,
    dataReceiver: PropTypes.func
};

module.exports = CompanyData;